import React, { useEffect, useState } from 'react';
import styles from './PrivacyPolicy.module.scss';
import DOMPurify from "dompurify";
import Seo, { seoPropsFor } from '../../components/Seo/Seo';
import { PAGE_SEO } from '../../content/site';

export default function PrivacyPolicyPage() {
    const [html, setHtml] = useState<string>("");

    // retrieval of privacy policy content from the doc
    useEffect(() => {
        const base = process.env.PUBLIC_URL || '';
        const url = `${base}/docs/privacy-policy.html`;
        const fetchUrl = `${url}?_=${Date.now()}`; // cache-buster

        console.info('Fetching privacy policy from:', fetchUrl);

        fetch(fetchUrl, { cache: 'no-store', credentials: 'same-origin' })
            .then(async response => {
                console.info('Fetch status:', response.status, response.statusText);
                const text = await response.text();
                console.debug('Fetched preview:', text.slice(0, 300));
                if (!response.ok) throw new Error(`HTTP ${response.status}`);
                if (!text || !text.trim()) throw new Error('Empty response body');
                // detect SPA fallback (index.html / app shell)
                if (text.includes('<div id="root"') || text.includes('<div id="app"') || /<script.*src=.*bundle/i.test(text)) {
                    throw new Error('Server returned app shell instead of the policy HTML. Check Amplify rewrites or file location.');
                }
                return text;
            })
            .then(htmlContent => {
                const sanitizedHtml = DOMPurify.sanitize(htmlContent, { ADD_ATTR: ['target'] });
                setHtml(sanitizedHtml);
            })
            .catch(err => {
                console.error('Failed to load privacy policy:', err);
                setHtml('<p>Unable to load privacy policy. Ensure /docs/privacy-policy.html is deployed and Amplify rewrites allow static files.</p>');
            });
    }, []);

    return (
        <div className={styles.privacyPolicy}>
            <Seo {...seoPropsFor(PAGE_SEO.privacyPolicy)} />
            <div className={styles.policyContainer}>
                <div dangerouslySetInnerHTML={{ __html: html }} />
            </div>
        </div>
    );
}
